'use strict';

module.exports = {
  videoPagesEnabled: false,
  micPagesEnabled: false,
  categoryPagination: true,
  topNavAdEnabled: false,
  newsPageEnable: false,
  gaCustomVarEnabled: false
};



// WEBPACK FOOTER //
// ./feature_flags.js